import React from "react";
import { Input, Button } from "antd";
import BlogEditor from "../../../../components/BlogEditor";
class BlogForm extends React.Component {
  constructor() {
    super();
    this.state = {
      title: "",
      author: "",
      coverImage: "",
      editorContent: "",
      editorText: "",
      highlightEditorContent: "",
      highlightEditorText: ""
    };

    this.submitBlogPost = this.submitBlogPost.bind(this);
  }
  componentDidMount() {
    this.setState({
      title: this.props.title,
      coverImage: this.props.coverImage
    });
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      title: nextProps.title,
      coverImage: nextProps.coverImage
    });
  }

  onChange = (editorContent, editorText) => {
    this.setState({ editorContent, editorText });
  };
  onChangeHighlight = (highlightEditorContent, highlightEditorText) => {
    this.setState({ highlightEditorContent, highlightEditorText });
  };

  onChangeInput = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  submitBlogPost() {
    const {
      title,
      author,
      coverImage,
      editorContent,
      editorText,
      highlightEditorContent,
      highlightEditorText
    } = this.state;

    this.props.saveBlogPost({
      title,
      author,
      coverImage,
      bodyHtml: editorContent,
      bodyText: editorText,
      highlightHtml: highlightEditorContent,
      highlightText: highlightEditorText
    });
  }
  render() {
    return [
      <div style={{ marginBottom: "20px" }}>
        <h2 style={{ textAlign: "left" }}>Headline</h2>
        <Input
          name="title"
          value={this.state.title}
          onChange={this.onChangeInput}
          size="large"
          placeholder="Enter blog headline"
        />
      </div>,
      <div style={{ marginBottom: "20px" }}>
        <h2 style={{ textAlign: "left" }}>Author</h2>
        <Input
          name="author"
          value={this.state.author}
          onChange={this.onChangeInput}
          size="large"
          placeholder="Enter author name"
        />
      </div>,
      <div style={{ marginBottom: "20px" }}>
        <h2 style={{ textAlign: "left" }}>Cover image</h2>
        <Input
          name="coverImage"
          value={this.state.coverImage}
          onChange={this.onChangeInput}
          size="large"
          placeholder="Enter image link here e.g. http://cat.png"
        />
      </div>,
      <div style={{ marginBottom: "20px" }}>
        <h2 style={{ textAlign: "left" }}>Highlighted section</h2>
        <BlogEditor
          text={this.props.highlightHtml}
          onChange={this.onChangeHighlight}
        />
      </div>,
      <div style={{ marginBottom: "20px" }}>
        <h2 style={{ textAlign: "left" }}>Body text</h2>
        <BlogEditor text={this.props.bodyHtml} onChange={this.onChange} />
      </div>,
      <div>
        <Button
          size="large"
          type="primary"
          style={{ width: "100%" }}
          onClick={this.submitBlogPost}
        >
          {this.props.updatingPost ? "Saving..." : "Save post"}
        </Button>
        {this.props.errorUpdating && (
          <span style={{ color: "red" }}>
            Something went wrong please try again
          </span>
        )}
      </div>
    ];
  }
}

export default BlogForm;



// WEBPACK FOOTER //
// ./src/pages/Admin/BlogDocument/BlogForm/component.js